<template lang="pug">
VueFeedback(type="no-result")
	template(slot="feedback-title") There are no items matching the search criteria
</template>

<script>
import VueFeedback from '@ui-common/vue-feedback';
export default {
	components: {
		VueFeedback
	}
};
</script>
